<template lang='slm'>
  .modal.fade
    .modal-dialog role="document" :class='size ? "modal-" + size : ""'
      .modal-content
        .modal-header
          h4.modal-title {{ title }}
          button.close v-if='showCloseButton' type="button" data-dismiss="modal" aria-label="Close"
            icon name='times' aria-hidden="true"
        .modal-body
          slot
            .jumbotron
        .modal-footer
          button.btn.btn-secondary.mr-2 v-if='showCloseButton' type="button" data-dismiss="modal" {{ closeButtonTitle }}
          button.btn.btn-primary v-if='showConfirmButton' type="button" @click='confirm' {{ confirmButtonTitle }}
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    confirmButtonTitle: {
      type: String,
      default: 'Сохранить',
    },
    closeButtonTitle: {
      type: String,
      default: 'Закрыть',
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openedForData: null,
    };
  },
  methods: {
    // opens modal. emits `beforeShow` event with provided data. called by parent
    open(data) {
      this.openedForData = data;
      if (this.content) {
        this.content.$validator.reset();
        this.content.$emit('beforeShow', data);
      }
      $(this.$el).modal('show');
    },
    // closes modal. called by parent
    close() {
      this.openedForData = null;
      $(this.$el).modal('hide');
    },
    // emits `confirm` event. called by children or on button click
    async confirm() {
      let valid = true;
      if (this.content) {
        valid = await this.content.$validator.validateAll();
      }
      if (valid) {
        this.$emit('confirm', this.contendData()); // removing vue reactivity
      }
    },
    // emits `remove` event. called on button click
    remove() {
      this.$emit('remove', this.contendData()); // removing vue reactivity
    },
    // emits `shown` event for children. called by `shown.bs.modal` hook
    modalShown() {
      if (this.content) {
        this.content.$emit('shown');
      } else {
        // use parentElement to detect [autofocus] on root content element
        const autofocusElement = this.$slots.default[0].elm.parentElement.querySelector('[autofocus]');
        if (autofocusElement) {
          autofocusElement.focus();
        }
      }
    },
    // get content data without reactivity
    contendData() {
      if (this.content) {
        return this.content.modalContentData == null ? null : this.content.modalContentData;
      }
      return this.openedForData;
    },
  },
  computed: {
    content() {
      return this.$slots.default && this.$slots.default[0].componentInstance;
    },
  },
  mounted() {
    $(this.$el).on('shown.bs.modal', this.modalShown);
    $(this.$el).on('hidden.bs.modal', () => {
      this.$emit('closed');
    });
  },
};
</script>
